import { AppHeader } from "../components/AppHeader"

export const PurchasePage = () => {    
  return (
    <>
      <div className="content colorbk">
        <AppHeader title="購買元寶"></AppHeader>
      </div>
      
      <div className="loginbg p-3 p-sm-5">
      <div className="loginmain px-3 px-sm-4 mx-1 mx-sm-5">
          <div>1元寶(USD)</div>
          <div className="txt-26 fw-600">TWD$30</div>
          <img src="https://ai.supercoin.network/img/chart.png" alt="" className="w-100 mt-4" />
      </div>
      <div className="p-2"></div>
      <div className="loginmain px-3 px-sm-4 mx-1 mx-sm-5">
        <label className="loginT mt-3" htmlFor="buyusd">支付方式</label>

        <div className="btn-group-vertical w-100" role="group" aria-label="Basic example">
          <a href="/wallet.html#cvisa" className="btn btn-outline-danger btn-block" style={{height: 50, lineHeight: 2}}>
            VISA<span className="txt-12 text-secondary ml-2">(卡支付)</span>
          </a>
          <a href="/wallet.html#cusdt" className="btn btn-outline-danger btn-block" style={{height: 50, lineHeight: 2}}>
            USDT<span className="txt-12 text-secondary ml-2">(閃兌元寶)</span>
          </a>
          <a href="https://c2c.huobi.com/zh-tw/trade/buy-usdt" target="_blank" className="btn btn-outline-danger btn-block" style={{height: 50, lineHeight: 2}} rel="noreferrer">
            P2P<span className="txt-12 text-secondary ml-2">(點對點)</span>
          </a>
        </div>

      </div>
        <div style={{'height': '100px'}}></div>
      </div>
    </>
  )
}